import React from 'react'
import HomeRunProfitabilityAccordion from './HomeRunProfitabilityAccordion'

const HomeRunProfitabilityList = ({ accordions, activeAccordion, changeActiveAccordion }) => {
  return (
    <ul className="dealmed-home-run__list">
      {accordions.map((accordion, index) => {
        return (
          <HomeRunProfitabilityAccordion
            key={index}
            accordion={accordion}
            isActive={activeAccordion === accordion}
            changeActiveAccordion={changeActiveAccordion}
          />
        )
      })}
    </ul>
  )
}

export default HomeRunProfitabilityList
